<script>
import PriceTable from './PriceTable.vue'
import DocumentProperties from './DocumentProperties.vue'
export default {
  components: {
    PriceTable,
    DocumentProperties
  },
  props: {
    headers: { type: Boolean },
    numbers: {
      type: Object,
      default() {
        return {
          1: Array.from({ length: 15 }, (_, i) => i + 1), // create array, begin with 1
          2: Array.from({ length: 14 }, (_, i) => i + 1),
          3: Array.from({ length: 4 }, (_, i) => i + 1),
          4: Array.from({ length: 4 }, (_, i) => i + 1)
        }
      }
    }
  }
}
</script>
<template>
  <v-expansion-panels>
    <div
      v-for="(item, index) in numbers"
      :key="index"
      class="v-item-group theme--light v-expansion-panels v-expansion-panels--focusable v-expansion-panels--popout" >
      <v-row v-if="headers"
      ><v-col>
        <h2 class="headline primary--text text--primary-2 pt-8 pb-4 ">
          {{ $t(`faq.part${index}.title`) }}
        </h2>
      </v-col>
      </v-row>
      <v-expansion-panel v-for="n in item" :key="n" class="background"
      ><v-expansion-panel-header>
        <h3
          class="font-weight-medium primary--text wordBreak"
          v-text="$t(`faq.part${index}.question${n}`)"
        ></h3></v-expansion-panel-header
      ><v-expansion-panel-content class="background-white"
      ><v-row class="pt-6 pb-2">
        <v-col
        ><p
          v-html="$t(`faq.part${index}.answer${n}`)" />
        </v-col>
      </v-row>
        <v-row justify="center">
          <v-col
            v-if="Number(index) === 1 && Number(n) === 3"
            cols="6"
            class="pb-6 px-md-12" >
            <PriceTable />
          </v-col>
          <v-col
            v-if="Number(index) === 2 && Number(n) === 3"
            class="pb-6 px-md-12" >
            <DocumentProperties
            /></v-col> </v-row></v-expansion-panel-content
      ></v-expansion-panel>
    </div>
  </v-expansion-panels>
</template>
<style lang="scss" scoped>
.background-white {
  background-color: white !important;
}
.background {
  background-color: var(--v-secondary) !important;
}
.v-expansion-panel:first-child {
  border-top: 1px solid;
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.v-expansion-panel--active {
  margin-top: 16px;
  margin-bottom: 16px;
}
.v-expansion-panel--active + .v-expansion-panel {
  margin-top: 0px;
}
</style>
